import React,{useEffect} from "react";
import { motion } from "framer-motion";
import BreadCrumb from "../Components/BreadCrumb";
import bgImg from '../Images/our-team-breadcrumb.webp';
import Cta from "../Components/Cta";
import Certificates from "../Components/Certificates";
import ContactSection from "../Components/ContactSection";
import { galleryData, team } from "../Data";
import TeamGrid from "../Components/TeamGrid";
import Gallery from "../Components/Gallery";
import extendedTeam1 from '../Images/extended-team-1.webp'
import extendedTeam2 from '../Images/extended-team-2.webp'
import videoImg from '../Images/group-companies-team.webp'
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import aboutPageSchema from "../Schema/AboutPageSchema";
import personSchema from "../Schema/PersonSchema";

const OurTeam=()=>{
    useEffect(() => {
                document.title =
                  "Our Group Companies & Team | Iris Impulse India Pvt. Ltd.";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Discover the skilled professionals driving Iris Impulse India Pvt. Ltd.'s success in delivering premium minerals worldwide. Explore organizational chart with the process."
                  );
                }
            
                 const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://irisimpulse.com/about-us/our-group-companies-team");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Our Group Companies & Team | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Discover the skilled professionals driving Iris Impulse India Pvt. Ltd.'s success in delivering premium minerals worldwide. Explore organizational chart with the process."
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://irisimpulse.com/about-us/our-group-companies-team");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/our-group-companies-team.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Our Group Companies & Team | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Discover the skilled professionals driving Iris Impulse India Pvt. Ltd.'s success in delivering premium minerals worldwide. Explore organizational chart with the process."
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/our-group-companies-team.webp"
                );
              }
              }, []);

    const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};

const fadeLeft = {
  hidden: { opacity: 0, x: -60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.9, ease: "easeOut" }
  }
};

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" }
  }
};

const staggerList = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const imageVariant = {
  hidden: {
    opacity: 0,
    scale: 0.96,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const organizationData = organizationSchema()
const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "About Us",
      url: "https://irisimpulse.com/about-us"
    },
    {
      name: "Our Group Companies, Leadership & Team",
    },
  ],
});
  const aboutPageData = aboutPageSchema({
  url: "https://irisimpulse.com/about-us/our-group-companies-team",
  title: "Our Group Companies & Team | Iris Impulse India Pvt. Ltd.",
  description:
    "Discover the skilled professionals driving Iris Impulse India Pvt. Ltd.'s success in delivering premium minerals worldwide. Explore organizational chart with the process.",
  image: "https://irisimpulse.com/Images/our-group-companies-team.webp",
});
  const teamMembers = [
  personSchema({
    name: "Mrs. Dhatri Raiyani",
    jobTitle: "Managing Director",
    description:
      "M.B.A. (International Business), M.Sc. (Microbiology) with 13 years of experience in marketing.",
    image: "https://irisimpulse.com/Images/dhatri-raiyani.webp",
    url: "https://irisimpulse.com/about-us/group-companies-team/",
  }),

  personSchema({
    name: "Mr. Kunal R. Kapta",
    jobTitle: "Director (Executive)",
    description:
      "B.Com (Gujarat University) with Twenty Years Of Mine & Mineral Industry experience.",
    image: "https://irisimpulse.com/Images/kunal-kapta.webp",
    url: "https://irisimpulse.com/about-us/group-companies-team/",
  }),

  personSchema({
    name: "Mr. Himanshu Raiyani",
    jobTitle: "Director (Technical)",
    description:
      "M.Tech (Chemical Engineering) with Fifteen Years Of Mine & Mineral Industry experience.",
    image: "https://irisimpulse.com/Images/himanshu-raiyani.webp",
    url: "https://irisimpulse.com/about-us/group-companies-team/",
  }),
];
    return(
        <>

        <SchemaMarkup data={organizationData} />
        <SchemaMarkup data={breadcrumbData} />
        <SchemaMarkup data={aboutPageData} />
        {teamMembers.map((member, index) => (
      <SchemaMarkup
        key={index}
        data={member}
      />
    ))}
          <BreadCrumb
  title="Our Group Companies, Leadership & Team" 
  bgImage={bgImg} 
/>

      {/**OUR INTEGRATED GROUP OF COMPANIES SECTION */}
      <section className="video-section container team-intro-section">
  

  <motion.div
    className="video-wrapper"
    variants={fadeLeft}
    initial="hidden"
    whileInView="visible"
   viewport={{ once: true, margin: "-50px" }}
  >
    {/*<iframe src="https://www.youtube.com/embed/hdMu89Qd9H8?rel=0&modestbranding=1" title="Iris Impulse Video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></iframe>*/}
    <img src={videoImg} alt="Our Integrated group of companies | Iris Impulse India Pvt. Ltd." />
  </motion.div>


  <motion.div
    className="content-wrapper"
    variants={container}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >

    <motion.h2 className="section-heading" variants={fadeUp}>
    OUR INTEGRATED GROUP OF COMPANIES
    </motion.h2>

    <motion.p className="section-text" variants={fadeUp}>
      <b className="bold">"IRIS”</b> is evolving its mineral heritage to create next-generation, high-performance products designed to solve real-world challenges for society, animal care, and the planet."
    </motion.p>

    <motion.p className="section-text" variants={fadeUp}>
     <b className="bold">Environmental Stewardship:</b> We take pride in preserving the core beliefs and wisdom inherited from our ancestors while dedicatedly defending the Earth's natural legacy.
    </motion.p>

    <motion.p className="section-text" variants={fadeUp}>
    <b className="bold">Technological Advancement:</b> Balancing deep-rooted traditions with a relentless pursuit of innovation, we provide high-performance, lean mineral solutions that set industry standards.
    </motion.p>
     <motion.div
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.2 }}
  variants={fadeUp}
>

  <motion.h3
    className="card-heading"
    variants={fadeUp}
  >
    GROUP OF COMPANIES
  </motion.h3>

  <motion.ol
    variants={staggerList}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >

    {[
      {
        title: "KUNAL TRADING",
        desc: "Involved in Traditional ecosensitive Mining Activities",
      },
      {
        title: "ASHIRWAD MINECHEM",
        desc: "Involved in Manufacturing Activities",
      },
      {
        title: "IRIS GREENIGEN PVT LTD",
        desc: "Involved in generation & selling of Renewable Energy.",
      },
      {
        title: "IRIS INNOVATIVE INFRA PVT LTD",
        desc: "Involved in Storage, Warehousing & Logistice solutions for Exporters and Importers from various part of INDIA.",
      },
      {
        title: "IRIS FOUNDATION",
        desc: "Iris Foundation is an important cultural player, working closely with local institutions and establishing beneficial connections with society.",
      },
    ].map((item, index) => (
      <motion.li
        key={index}
        variants={fadeUp}
        whileHover={{
          x: 6,
          transition: { duration: 0.2 },
        }}
      >
        <strong>{item.title}:</strong> {item.desc}
      </motion.li>
    ))}

  </motion.ol>

</motion.div>

    <motion.div className="btn-group" variants={fadeUp}>
      <motion.a
      href="/about-us"
        className="black-btn"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.97 }}
      >
        KNOW MORE
      </motion.a>

      <motion.a
      href="/contact-us"
        className="outline-btn"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.97 }}
      >
        SEND AN ENQUIRY
      </motion.a>
    </motion.div>
  </motion.div>
</section>

    {/**LEADERSHIP SPOTLIGHT SECTION */}
    <TeamGrid
  heading="LEADERSHIP SPOTLIGHT"
  description={<>The leadership team at <b className="bold">Iris Impulse India Pvt. Ltd.</b>, Kutch, Gujarat, India, drives the company’s vision with expertise, innovation, and integrity. Guided by years of industry experience, our leaders ensure operational excellence, sustainable growth, and global competitiveness while fostering a culture of trust, collaboration, and customer-centricity.</>}
  data={team}
/>

<motion.section
  className="extended-section container"
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.2 }}
  variants={staggerContainer}
>

  <motion.h2
    className="section-heading"
    variants={fadeUp}
  >
    Extended Leadership Team
  </motion.h2>

  <motion.p
    className="section-text"
    variants={fadeUp}
  >
    The Extended Leadership Team at <b className="bold">Iris Impulse India Pvt. Ltd.</b>
    comprises experienced professionals who support strategic
    decision-making and operational excellence. With expertise across
    mining, production, quality control, and logistics, they ensure the
    company delivers consistent results, sustainable growth, and
    innovative solutions for clients worldwide.
  </motion.p>

  <motion.div
    className="extended-grid"
    variants={staggerContainer}
  >

    <motion.div
      variants={imageVariant}
      whileHover={{
        y: -8,
        scale: 1.08,
      }}
      transition={{ duration: 0.3 }}
    >
      <img
        src={extendedTeam1}
        alt="Extended Leadership Team 1 | Iris Impulse India Pvt. Ltd."
      />
    </motion.div>

    <motion.div
      variants={imageVariant}
      whileHover={{
        y: -8,
        scale: 1.08,
      }}
      transition={{ duration: 0.3 }}
    >
      <img
        src={extendedTeam2}
        alt="Extended Leadership Team 2 | Iris Impulse India Pvt. Ltd."
      />
    </motion.div>

  </motion.div>

</motion.section>

    {/**CULTURE SNAPSHOT SECTION */}
    <Gallery
  heading="Culture Snapshot"
  description={<>At <b className="bold">Iris Impulse India Pvt. Ltd.</b>, our culture is built on collaboration, innovation, and integrity. We foster an environment where every team member is empowered to contribute, learn, and grow. By valuing creativity, accountability, and diversity, we ensure a workplace that drives operational excellence, sustainable practices, and global competitiveness while keeping employee well-being at the core.</>}
  images={galleryData}
  showCaption={true}
/>

     {/**CTA SECTION */}
    <Cta />

    {/**CERTIFICATES SECTION */}
    <Certificates/>

    {/**CONTACT FORM SECTION */}
    <ContactSection />
        </>
    )
}
export default OurTeam;